(function () {
  function initSocialUGCModal() {
    document.querySelectorAll('.social-ugc-carousel--modal').forEach(function (carousel) {
      var triggers = carousel.querySelectorAll('.social-ugc-carousel__media-trigger');
      var modal = carousel.querySelector('.social-ugc-carousel-video-modal');
      var slot = modal && modal.querySelector('.social-ugc-carousel-video-modal__video-slot');
      if (!triggers.length || !modal || !slot) return;

      function injectVideo(videoUrl) {
        if (!videoUrl) return;
        slot.innerHTML = '';
        var video = document.createElement('video');
        video.src = videoUrl;
        video.controls = true;
        video.playsInline = true;
        video.muted = true; // required for autoplay per browser policy
        video.autoplay = true;
        video.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;';
        slot.appendChild(video);

        video.addEventListener('ended', function () {
          video.pause();
        });

        modal.addEventListener('modal:handleAfterHide', function cleanup() {
          if (slot.contains(video)) {
            video.pause();
            video.src = '';
            slot.removeChild(video);
          }
          modal.removeEventListener('modal:handleAfterHide', cleanup);
        }, { once: true });
      }

      modal.addEventListener('modal:handleAfterShow', function () {
        var pending = modal.getAttribute('data-pending-video');
        if (pending) {
          modal.removeAttribute('data-pending-video');
          injectVideo(pending);
        }
      });

      triggers.forEach(function (trigger) {
        var slide = trigger.closest('.social-ugc-carousel__slide--modal-trigger');
        if (!slide) return;

        var videoUrl = slide.dataset.videoUrl;
        if (!videoUrl) return;

        trigger.addEventListener('click', function () {
          modal.setAttribute('data-pending-video', videoUrl);
        }, true);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSocialUGCModal);
  } else {
    initSocialUGCModal();
  }
})();
